export const FEAT_TYPE_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "description", "parentTypeId", "removeFeatureType" ]
        } ],
        "columns" : [ {
            "name" : "productFeatureTypeId",
            "title" : "Product Feature Type ID"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "parentTypeId",
            "title" : "Parent Type ID"
        }, {
            "name" : "removeFeatureType",
            "title" : "Delete"
        } ],
        "formName" : "ListFeatureTypes",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Product Feature Type ID",
            "type" : "HYPERLINK",
            "target" : "EditFeatureType",
            "name" : "productFeatureTypeId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productFeatureTypeId"
            } ],
            "style" : "",
            "id" : "ListFeatureTypes_productFeatureTypeId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"EditFeatureType",
                "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
            },
            "event":"edit"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListFeatureTypes_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_b2cb87a7_1f8b_4ea6_b66a_1559872952f4",
            "target" : "EditFeatureType",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditFeatureType",
                    "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
                }
            }
            },
            "event":"edit",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "parentTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListFeatureTypes_parentTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete",
            "type" : "HYPERLINK",
            "target" : "removeProductFeatureType",
            "name" : "removeFeatureType",
            "width" : "",
            "parameterList" : [ {
            "name" : "productFeatureTypeId"
            } ],
            "style" : "",
            "id" : "ListFeatureTypes_removeFeatureType",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"removeProductFeatureType",
                "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
            },
            "event":"delete"
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureTypeId", "parentTypeId", "hasTable", "description", "submitButton" ]
        } ],
        "formName" : "EditFeatureType",
        "altTarget" : [ {
            "useWhen" : "productFeatureType==null",
            "targetExdr" : {
            "chars" : "createProductFeatureType",
            "hint" : 20,
            "empty" : false,
            "original" : "createProductFeatureType"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "hasTable",
            "action" : "",
            "id" : "EditFeatureType_hasTable",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Feature Type ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productFeatureTypeId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFeatureType_productFeatureTypeId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Parent Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFeatureType",
            "options" : [ {
            "description" : "Accessory",
            "key" : "ACCESSORY"
            }, {
            "description" : "Amount",
            "key" : "AMOUNT"
            }, {
            "description" : "Artist",
            "key" : "ARTIST"
            }, {
            "description" : "Billing Feature",
            "key" : "BILLING_FEATURE"
            }, {
            "description" : "Brand",
            "key" : "BRAND"
            }, {
            "description" : "Care",
            "key" : "CARE"
            }, {
            "description" : "Color",
            "key" : "COLOR"
            }, {
            "description" : "Dimension",
            "key" : "DIMENSION"
            }, {
            "description" : "Equipment Class",
            "key" : "EQUIP_CLASS"
            }, {
            "description" : "Fabric",
            "key" : "FABRIC"
            }, {
            "description" : "Genre",
            "key" : "GENRE"
            }, {
            "description" : "Gift Wrap",
            "key" : "GIFT_WRAP"
            }, {
            "description" : "Hardware Feature",
            "key" : "HARDWARE_FEATURE"
            }, {
            "description" : "Hazmat",
            "key" : "HAZMAT"
            }, {
            "description" : "License",
            "key" : "LICENSE"
            }, {
            "description" : "Model Year",
            "key" : "MODEL_YEAR"
            }, {
            "description" : "Net Weight",
            "key" : "NET_WEIGHT"
            }, {
            "description" : "Origin",
            "key" : "ORIGIN"
            }, {
            "description" : "Other Feature",
            "key" : "OTHER_FEATURE"
            }, {
            "description" : "Product Quality",
            "key" : "PRODUCT_QUALITY"
            }, {
            "description" : "Size",
            "key" : "SIZE"
            }, {
            "description" : "Software Feature",
            "key" : "SOFTWARE_FEATURE"
            }, {
            "description" : "Style",
            "key" : "STYLE"
            }, {
            "description" : "Symptom",
            "key" : "SYMPTOM"
            }, {
            "description" : "Topic",
            "key" : "TOPIC"
            }, {
            "description" : "Type",
            "key" : "TYPE"
            }, {
            "description" : "Warranty",
            "key" : "WARRANTY"
            }, {
            "description" : "Year Made",
            "key" : "YEAR_MADE"
            } ],
            "disabled" : "false",
            "id" : "EditFeatureType_parentTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "parentTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFeatureType_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditFeatureType",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditFeatureType_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductFeatureType"

    }

]